module.exports = __webpack_public_path__ + "static/media/a-smarter-harvest-desktop.fedfecc9.jpg";